import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { useMutation } from '@apollo/client';
import { EDIT_MEMBER_APPROVAL_REQUEST } from '../gql';
import { LoadingButton } from '@mui/lab';
import { ApprovalRequestType } from '../../common/utils/enum';

interface ApproveRejectDialogProps {
  id: string;
  open: boolean;
  comment: string;
  handleClose: () => void;
  setApprovelStatus?: (value: { status: string }) => void;
}

const ApproveDialog: React.FC<ApproveRejectDialogProps> = ({
  id,
  open,
  comment,
  handleClose,
  setApprovelStatus
}) => {
  const [editMemberApprovalRequest] = useMutation(EDIT_MEMBER_APPROVAL_REQUEST);

  const handleApprove = async (): Promise<void> => {
    try {
      handleClose();
      if (setApprovelStatus) {
        setApprovelStatus({ status: ApprovalRequestType.APPROVED });
      }
      await editMemberApprovalRequest({
        variables: {
          input: {
            id,
            action: 'APPROVE',
            comment
          }
        }
      });
    } catch (error) {
      if (setApprovelStatus) {
        setApprovelStatus({ status: ApprovalRequestType.PENDING });
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '28px',
          backgroundColor: '#f4f2fd'
        }
      }}
    >
      <DialogContent sx={{ padding: '0', justifyContent: 'center' }}>
        <DialogContentText
          sx={{
            display: 'flex',
            fontSize: '24px',
            padding: '36px 84px',
            textAlign: 'center',
            color: '#1A1B1F'
          }}
        >
          Are you sure you want to approve this request?
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '24px 32px'
        }}
      >
        <Button
          sx={{
            textTransform: 'none',
            fontSize: '18px',
            color: '#295DAB',
            fontWeight: '500'
          }}
          onClick={() => {
            if (setApprovelStatus) {
              setApprovelStatus({ status: ApprovalRequestType.PENDING });
            }
            handleClose();
          }}
        >
          Decline
        </Button>
        <LoadingButton
          sx={{
            textTransform: 'none',
            fontSize: '18px',
            color: '#295DAB',
            fontWeight: '500'
          }}
          onClick={() => {
            void (async () => {
              await handleApprove();
            })();
          }}
          autoFocus
        >
          Yes, Approve
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ApproveDialog;
